import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-bstoast',
	templateUrl:'./BSToastPage.html',
	styles: [],
	styleUrls:['./BSToastPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class BSToastPage
{
	mdContent_170 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.toasts.BSToast;
\`\`\``;
	mdContent_171 = `\`\`\`java
new BSToast<>()
\`\`\``;
	mdContent_172 = `\`\`\`java
var toast = new BSToast<>();
toast.getToastHeader().setText("Notification");
toast.getToastBody().setText("You have a new message.");
toast.setAutoHide(true);
toast.setShowDelay(5000);
\`\`\``;
}
